export default class Doublent {
  constructor(data) {
    this.id = data.id;
    this.annee = data.annee;
    this.semaine = data.semaine;
    this.depot = data.depot;
    this.numero_dossier = data.numero_dossier;
    this.nom1 = data.nom1;
    this.prenom1 = data.prenom1;
    this.adresse = data.adresse;
    this.code_postal = data.code_postal;
    this.departement = data.departement;
    this.type_de_projet = data.type_de_projet;
    this.ville = data.ville;
    this.mobile = data.mobile;
    this.fixe = data.fixe;
    this.etape = data.etape;
    this.categorie = data.categorie;
    this.statut = data.statut;
    this.organisme = data.organisme;
    this.regie = data.regie;
    this.installeur_rge = data.installeur_rge;
    this.previsiteur = data.previsiteur;
    this.previsite_date = data.previsite_date;
    this.agent_commercial_terrain = data.agent_commercial_terrain;
    this.confirmateur = data.confirmateur;
    this.administrateur = data.administrateur;
    this.pose_date = data.pose_date;
    this.pose_semaine = data.pose_semaine;
    this.poseur = data.poseur;
    this.coef_ratio_prime = data.coef_ratio_prime;
    this.montant_101 = data.montant_101;
    this.montant_102 = data.montant_102;
    this.montant_103 = data.montant_103;
    this.montant_total_ht = data.montant_total_ht;
    this.montant_total_ttc = data.montant_total_ttc;
    this.surface_101 = data.surface_101;
    this.surface_102 = data.surface_102;
    this.surface_103 = data.surface_103;
    this.surface_101_cp_deroule = data.surface_101_cp_deroule;
    this.surface_101_cp_souffle = data.surface_101_cp_souffle;
    this.surface_101_rampant = data.surface_101_rampant;
    this.surface_102_murs = data.surface_102_murs;
    this.surface_102_pignons = data.surface_102_pignons;
    this.surface_102_murs_iti = data.surface_102_murs_iti;
    this.surface_102_murs_ite = data.surface_102_murs_ite;
    this.surface_103_plafonds = data.surface_103_plafonds;
    this.surface_103_vide_sanitaire = data.surface_103_vide_sanitaire;
    this.surface_103_plafond_sous_sol = data.surface_103_plafond_sous_sol;
    this.surface_103_plafond_garage = data.surface_103_plafond_garage;
    this.surface_103_plafond_cave = data.surface_103_plafond_cave;
    this.surface_103_plafond_autres = data.surface_103_plafond_autres;
    this.total_surface_a_isoler = data.total_surface_a_isoler;
    this.cumac_101 = data.cumac_101;
    this.cumac_102 = data.cumac_102;
    this.cumac_103 = data.cumac_103;
    this.kwh_cumac = data.kwh_cumac;
    this.precarite = data.precarite;
    this.type_chauffage = data.type_chauffage;
    this.personnes_au_foyer = data.personnes_au_foyer;
    this.numero_facture = data.numero_facture;
    this.numero_lot = data.numero_lot;
    this.num_depot = data.num_depot;
    this.date_devis = data.date_devis;
    this.date_facture = data.date_facture;
    this.coposeurs = data.coposeurs;
    this.revenu_fiscal_ref = data.revenu_fiscal_ref;
    this.date_depot_dossier = data.date_depot_dossier;
    this.email = data.email;
    this.societe_poseur = data.societe_poseur;
    this.responsable_zone = data.responsable_zone;
    this.depot_stockage = data.depot_stockage;
    this.source = data.source;
    this.pipedrive_lead_id = data.pipedrive_lead_id;
    this.date_creation_fiche = data.date_creation_fiche;
    this.type_lead = data.type_lead;
    this.commentaire = data.commentaire;
    this.zone_climatique = data.zone_climatique;
    this.montant_operation = data.montant_operation;
    this.total_prime_ttc_101 = data.total_prime_ttc_101;
    this.total_prime_ttc_102 = data.total_prime_ttc_102;
    this.total_prime_ttc_103 = data.total_prime_ttc_103;
    this.total_commission_tcc = data.total_commission_tcc;
    this.regie_id = data.regie_id;
    this.previsiteur_id = data.previsiteur_id;
    this.sedentaire_id = data.sedentaire_id;
    this.commercial_terrain_id = data.commercial_terrain_id;
    this.poseur_id = data.poseur_id;
    this.coposeur_id = data.coposeur_id;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.statue = data.statue;
    this.commercial_regie = data.commercial_regie;
    this.montant_MPR = data.montant_MPR;
    this.montant_prime_CEE = data.montant_prime_CEE;
    this.dossier_MPR = data.dossier_MPR;
    this.dossier_referance = data.dossier_referance;
    this.reste_a_charge = data.reste_a_charge;
    this.couleur = data.couleur;
    this.a_3_euro = data.a_3_euro;
    this.a_2_euro = data.a_2_euro;
  }
  update(data) {
    this.id = data.id;
    this.annee = data.annee;
    this.semaine = data.semaine;
    this.depot = data.depot;
    this.numero_dossier = data.numero_dossier;
    this.nom1 = data.nom1;
    this.prenom1 = data.prenom1;
    this.adresse = data.adresse;
    this.code_postal = data.code_postal;
    this.departement = data.departement;
    this.type_de_projet = data.type_de_projet;
    this.ville = data.ville;
    this.mobile = data.mobile;
    this.fixe = data.fixe;
    this.etape = data.etape;
    this.categorie = data.categorie;
    this.statut = data.statut;
    this.organisme = data.organisme;
    this.regie = data.regie;
    this.installeur_rge = data.installeur_rge;
    this.previsiteur = data.previsiteur;
    this.previsite_date = data.previsite_date;
    this.agent_commercial_terrain = data.agent_commercial_terrain;
    this.confirmateur = data.confirmateur;
    this.administrateur = data.administrateur;
    this.pose_date = data.pose_date;
    this.pose_semaine = data.pose_semaine;
    this.poseur = data.poseur;
    this.coef_ratio_prime = data.coef_ratio_prime;
    this.montant_101 = data.montant_101;
    this.montant_102 = data.montant_102;
    this.montant_103 = data.montant_103;
    this.montant_total_ht = data.montant_total_ht;
    this.montant_total_ttc = data.montant_total_ttc;
    this.surface_101 = data.surface_101;
    this.surface_102 = data.surface_102;
    this.surface_103 = data.surface_103;
    this.surface_101_cp_deroule = data.surface_101_cp_deroule;
    this.surface_101_cp_souffle = data.surface_101_cp_souffle;
    this.surface_101_rampant = data.surface_101_rampant;
    this.surface_102_murs = data.surface_102_murs;
    this.surface_102_pignons = data.surface_102_pignons;
    this.surface_102_murs_iti = data.surface_102_murs_iti;
    this.surface_102_murs_ite = data.surface_102_murs_ite;
    this.surface_103_plafonds = data.surface_103_plafonds;
    this.surface_103_vide_sanitaire = data.surface_103_vide_sanitaire;
    this.surface_103_plafond_sous_sol = data.surface_103_plafond_sous_sol;
    this.surface_103_plafond_garage = data.surface_103_plafond_garage;
    this.surface_103_plafond_cave = data.surface_103_plafond_cave;
    this.surface_103_plafond_autres = data.surface_103_plafond_autres;
    this.total_surface_a_isoler = data.total_surface_a_isoler;
    this.cumac_101 = data.cumac_101;
    this.cumac_102 = data.cumac_102;
    this.cumac_103 = data.cumac_103;
    this.kwh_cumac = data.kwh_cumac;
    this.precarite = data.precarite;
    this.type_chauffage = data.type_chauffage;
    this.personnes_au_foyer = data.personnes_au_foyer;
    this.numero_facture = data.numero_facture;
    this.numero_lot = data.numero_lot;
    this.num_depot = data.num_depot;
    this.date_devis = data.date_devis;
    this.date_facture = data.date_facture;
    this.coposeurs = data.coposeurs;
    this.revenu_fiscal_ref = data.revenu_fiscal_ref;
    this.date_depot_dossier = data.date_depot_dossier;
    this.email = data.email;
    this.societe_poseur = data.societe_poseur;
    this.responsable_zone = data.responsable_zone;
    this.depot_stockage = data.depot_stockage;
    this.source = data.source;
    this.pipedrive_lead_id = data.pipedrive_lead_id;
    this.date_creation_fiche = data.date_creation_fiche;
    this.type_lead = data.type_lead;
    this.commentaire = data.commentaire;
    this.zone_climatique = data.zone_climatique;
    this.montant_operation = data.montant_operation;
    this.total_prime_ttc_101 = data.total_prime_ttc_101;
    this.total_prime_ttc_102 = data.total_prime_ttc_102;
    this.total_prime_ttc_103 = data.total_prime_ttc_103;
    this.total_commission_tcc = data.total_commission_tcc;
    this.regie_id = data.regie_id;
    this.previsiteur_id = data.previsiteur_id;
    this.sedentaire_id = data.sedentaire_id;
    this.commercial_terrain_id = data.commercial_terrain_id;
    this.poseur_id = data.poseur_id;
    this.coposeur_id = data.coposeur_id;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.statue = data.statue;
    this.commercial_regie = data.commercial_regie;
    this.montant_MPR = data.montant_MPR;
    this.montant_prime_CEE = data.montant_prime_CEE;
    this.dossier_MPR = data.dossier_MPR;
    this.dossier_referance = data.dossier_referance;
    this.reste_a_charge = data.reste_a_charge;
    this.couleur = data.couleur;
    this.a_3_euro = data.a_3_euro;
    this.a_2_euro = data.a_2_euro;
  }
  static create(data) {
    return new Doublent(data);
  }
}
